import { matchPath } from "react-router";

// React Router matches routes on this decoding of the location pathname; its `decodePath` is not exported.
function decodeRouterPathname(pathname: string): string {
  try {
    return pathname
      .split("/")
      .map((segment) => decodeURIComponent(segment).replace(/\//g, "%2F"))
      .join("/");
  } catch {
    return pathname;
  }
}

/** Whether `pattern` (with `:param` and trailing `/*`) matches `pathname` as a route does: decoded, any letter case. */
export function matchesRouterPath(pattern: string, pathname: string): boolean {
  return (
    matchPath(
      { path: pattern, caseSensitive: false, end: true },
      decodeRouterPathname(pathname),
    ) !== null
  );
}
